import type { DialogProfileDto } from "../../types/DialogProfileDto";
import type { DialogProfileEntity } from "../../types/DialogProfileEntity";

export const DialogProfileEntityToDto = ({ ...rest }: Readonly<DialogProfileEntity>): DialogProfileDto => {
    return { ...rest };
};
